var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGravityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "36px",
    viewBox: "0 0 38 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4,25.2 L16.4,25.2 C16.1,25.6 15.8,25.3 15.5,25.4 C16.1,25.2 16.4,25.2 16.4,25.2 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6,6.6 L36.2,5.7 C36.1,5.6 36,5.6 36,5.7 C32.9,12.3 23.3,20.7 7.6,19.6 C6.8,19.5 6,19.5 5.1,19.3 L5,19.3 C4.8,19.3 4.7,19.3 4.5,19.2 C4.3,19.2 4,19.1 3.8,19.1 C3.7,19.1 3.6,19.2 3.6,19.3 L6.8,25.6 L6.9,25.7 C7.5,25.7 8.1,25.8 8.8,25.8 C9.1,25.8 9.5,25.8 10.1,25.9 L11,25.9 L11.2,25.9 L12.4,25.9 L12.5,25.9 C13.4,25.9 14.3,25.8 15.2,25.6 L15.3,25.6 C15.6,25.6 15.9,25.5 16.2,25.5 C26.8,23.5 33.9,15.2 36.6,6.6 L36.6,6.6 Z",
    id: "Shape",
    fill: "#4E4E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7,7 C32.8,6.9 32.8,6.8 32.7,6.7 L29.7,1 C29.4,0.4 28.8,0 28.1,0 L27.8,0 L25.7,0.3 L25.7,0.3 L1.7,3.4 L1.7,3.4 C0.7,3.6 0,4.3 0,5.3 C0,5.6 0.1,6 0.2,6.2 L5.6,16.7 C5.6,16.8 5.7,16.8 5.8,16.8 C6.7,17 7.3,17 8.2,17.1 C17.8,17.4 28.9,13 32.7,7 Z",
    id: "Shape",
    fill: "#54A754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8,16.6 L37.8,16.6 L36.2,13.5 C36.1,13.3 35.9,13.3 35.8,13.5 C32.4,20.2 23.6,28.2 14,28.7 L11.9,28.7 C11.8,28.7 11.8,28.8 11.8,28.8 L14.8,34.6 L14.9,34.8 L14.9,34.8 C15,34.9 15.1,35.1 15.2,35.2 C15.9,35.9 17,36 17.8,35.3 L37.3,19 L37.3,19 L37.4,18.9 C38,18.2 38.1,17.3 37.8,16.6 Z",
    id: "Shape",
    fill: "#54A754"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGravityIcon);
export default __webpack_public_path__ + "static/media/GravityIcon.0ec26778.svg";
export { ForwardRef as ReactComponent };